export default "__VITE_ASSET__e34c5cd5__"